const contractTitlesInitialState = {
  titles: [],
  loading: false,
  error: null,
};

export const contractHistoryReducer = (state = {}, action) => {
  switch (action.type) {
    case "CONTRACT_HISTORY_REQUEST":
      return { loading: true };
    case "CONTRACT_HISTORY_SUCCESS":
      return {
        loading: false,
        history: action.payload,
        historyReset: false,
        chatId: action.payload.chatId,
      };
    case "CONTRACT_HISTORY_FAIL":
      return { loading: false, error: action.payload };
    case "CONTRACT_HISTORY_RESET":
      return {};
    default:
      return state;
  }
};

export const editContractTitleReducer = (state = {}, action) => {
  switch (action.type) {
    case "EDIT_CONTRACT_TITLE_REQUEST":
      return { loading: true };
    case "EDIT_CONTRACT_TITLE_SUCCESS":
      return { loading: false, message: action.payload, success: true };
    case "EDIT_CONTRACT_TITLE_FAIL":
      return { loading: false, error: action.payload };
    case "EDIT_CONTRACT_TITLE_RESET":
      return {};
    default:
      return state;
  }
};

export const deleteContractReducer = (state = {}, action) => {
  switch (action.type) {
    case "DELETE_CONTRACT_REQUEST":
      return { loading: true };
    case "DELETE_CONTRACT_SUCCESS":
      return { loading: false, message: action.payload, success: true };
    case "DELETE_CONTRACT_FAIL":
      return { loading: false, error: action.payload };
    case "DELETE_CONTRACT_RESET":
      return {};
    default:
      return state;
  }
};

export const newcontractReducer = (state = {}, action) => {
  switch (action.type) {
    case "NEW_CONTRACT_REQUEST":
      return { isClicked: true };
    case "NEW_CONTRACT_RESET":
      return {};
    default:
      return state;
  }
};

export const selectedContractReducer = (state = {}, action) => {
  switch (action.type) {
    case "SET_SELECTED_CONTRACT":
      return { selectedApp: action.payload };
    case "SELECTED_CONTRACT_RESET":
      return {};
    default:
      return state;
  }
};

export const contractTitlesReducer = (
  state = contractTitlesInitialState,
  action
) => {
  switch (action.type) {
    case "GET_CONTRACT_TITLES_REQUEST":
      return {
        ...state,
        loading: true,
        error: "",
      };
    case "GET_CONTRACT_TITLES_SUCCESS":
      return {
        ...state,
        titles: action.payload,
        loading: false,
        error: "",
      };
    case "EDIT_CONTRACT_TITLE":
      return {
        ...state,
        titles: state.titles?.map((title) =>
          title.chat_id === action.payload.chatId
            ? { ...title, Title: action.payload.newTitle }
            : title
        ),
        error: "",
      };
    case "DELETE_CONTRACT_TITLE":
      return {
        ...state,
        titles: state.titles?.filter(
          (chat) => chat.chat_id !== action.payload.chatId
        ),
        error: "",
      };
    case "TOGGLE_PIN_CONTRACT":
      return {
        ...state,
        titles: state.titles?.map((chat) =>
          chat.chat_id === action.payload.chatId
            ? { ...chat, isPinned: action.payload.isPinned }
            : chat
        ),
        error: "",
      };
    case "UPDATE_IS_SAVED_CONTRACT":
      return {
        ...state,
        titles: state.titles?.map((chat) =>
          chat.chat_id === action.payload.chatId
            ? { ...chat, isSaved: true }
            : chat
        ),
      };
    case "GET_CONTRACT_TITLES_FAIL":
      return { loading: false, error: action.payload };
    case "GET_CONTRACT_TITLES_RESET":
      return contractTitlesInitialState;
    default:
      return state;
  }
};
